/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const echobox: CommunityData = {
  code: "echobox",
  inviteCode: "echobox",
  name: "Echobox",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/echobox`,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: "/assets/customizations/echobox/logo.png",
        styles: "w-[122px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/echobox/logo-2.png",
        styles: "w-[122px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[1px] border-[#FFFFFF]",
      bgColor: "#000000",
      asideBg: "#040608",
      asideStyles: "border-r-[#FFFFFF] border-r",
      contentBg: "#040608",
      bgDesktop: "/assets/customizations/echobox/bg.png",
      bgMobile: "/assets/customizations/echobox/bg.png",
      mainFont: "font-['Gramatika']",
      primaryButton:
        "flex mt-2 rounded-full text-bold justify-center items-center !text-[24px] pt-1 !h-[48px] bg-[#FFFFFF] uppercase !text-[#000000] sm:!min-w-[186px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFFFFF",
      separator: "border-t-[#FFFFFF] border-t",
      item: "text-[20px] font-bold text-[#FFFFFF] h-[40px] flex sm:justify-start justify-center items-center sm:!pt-1 !pt-5",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[40px] text-[#FB5058] font-bold leading-[40px]",
      announcements: {
        lg: {
          title:
            "!text-[14px] -mb-1 font-bold mt-[-4px] px-[6px] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
          subtitle:
            "!text-[14px] px-[6px] !bg-[#000000] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
        },
        sm: {
          title:
            "!text-[14px] mb-1 font-bold mt-[-4px] px-[6px] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
          subtitle:
            "!text-[14px] px-[6px] !bg-[#000000] w-fit !text-[#FFFFFF] h-[19px] flex items-center",
        },
      },
      event: {
        title: "text-[20px] text-[#FFFFFF] one-line-truncate font-bold",
        subtitle: "text-[#FFFFFF] text-[16px] leading-[18px]",
      },
      shop: {
        title: "text-[20px] text-[#FFFFFF] font-bold",
        text: "text-[#FFFFFF] text-[16px] leading-[18px]",
        customShopImage: "/assets/customizations/echobox/shop.png",
      },
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
    },
    announcements: {
      created: "text-[#FFFFFF] text-[16px] leading-[18px]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[40px] font-bold text-[#FFFFFF]",
      title: "text-[20px] font-bold text-[#FFFFFF]",
      description: "text-[#FFFFFF] text-[14px] leading-[16px]",
    },
    announcement: {
      likeCount: "text-[#FFFFFF]",
      commentCount: "text-[#FFFFFF]",
      created: "text-[#FFFFFF] text-[14px] leading-[16px]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "text-[40px] font-bold text-[#FFFFFF]",
      description: "text-[#FFFFFF] text-[14px] leading-[16px]",
      commentIconColor: "#FFFFFF",
      likeIconColor: "#FFFFFF",
    },
    events: {
      sectionHeader: "text-[20px] text-[#FFFFFF] font-bold",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[40px] font-bold text-[#FFFFFF]",
      title: "text-[20px] font-bold text-[#FFFFFF]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      duration: "mb-4 text-[#FFFFFF] text-[14px] leading-[16px]",
      address: "text-[#FFFFFF] text-[14px] leading-[16px]",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#FFFFFF]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      header: "text-[40px] leading-[45px] font-bold text-[#FFFFFF] !mt-0 sm:mb-0 mb-[24px]",
      sectionTitle: "text-[20px] font-bold text-[#FFFFFF]",
      sectionSubtitle: "text-[#FFFFFF] !font-['Gramatika'] !text-[18px] leading-[18px]",
      text: "text-[#FFFFFF] text-[16px] leading-[18px]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#FFFFFF]",
      map: {
        pin: "",
        border: "mb-2 border-[1px] border-[#FFFFFF] overflow-hidden",
        pinColor: "#FFFFFF",
        strokeColor: "#FFFFFF",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "!mt-0 text-[40px] leading-[45px] font-bold text-[#FFFFFF]",
        subtitle: "text-[#FFFFFF] !font-['Gramatika'] !text-[18px] leading-[18px]",
      },
      ticket: {
        title: "text-[20px] text-bold text-[#FFFFFF]",
        description: "text-[#FFFFFF] text-[18px] leading-[20px]",
        text: "text-[#FFFFFF] text-[16px] leading-[18px]",
        price: "text-[20px] text-[#FFFFFF] text-bold ",
        counterContainer: "text-[20px] !text-[#000] font-bold rounded-full !bg-[#FFFFFF]",
        quantity: "text-nowrap text-[20px] bg-[#FFFFFF] rounded-full font-bold",
      },
      separator: "sm:my-8 my-6 border-b-[#FFFFFF] border-b-[1px]",
    },
    shop: {},
    linktree: {
      container:
        "font-['Gramatika'] flex flex-col items-center h-full w-full bg-cover min-h-screen relative bg-[#000000] p-[64px]",
      bgDesktop: "/assets/customizations/echobox/bg.png",
      bgMobile: "/assets/customizations/echobox/bg.png",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[#FFFFFF] border-[2px]",
        name: "text-[30px] mt-2 text-[#FFFFFF] uppercase font-bold",
        location: "text-[18px] opacity-[80%] text-[#FFFFFF] mb-2",
        description: "text-[18px] text-[#FFFFFF] leading-[20px] text-center mb-4",
        socialMediaIconColor: "#FFFFFF",
        button:
          "flex font-bold px-[32px] rounded-full text-bold justify-center items-center !text-[24px] !h-[48px] bg-[#FFFFFF] !text-[#000000] text-nowrap cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] rounded-full border-[2px] border-[#FFFFFF] !h-[56px] text-[#FFFFFF] text-[#FFFFFF] sm:w-[500px] w-[95vw] p-4 flex bg-[#000000] items-center text-[18px]",
        emptyState: {
          container:
            "border-[#FFFFFF] border-[1px] sm:w-[500px] w-[95vw] bg-[#000000] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "text-[16px] uppercase text-[#FFFFFF] text-center",
          text: "text-[12px] text-[#FFFFFF] uppercase",
          button:
            "flex font-bold mt-4 px-[32px] rounded-full text-bold justify-center items-center !text-[24px] !h-[48px] bg-[#FFFFFF] !text-[#000000] text-nowrap cursor-pointer",
        },
        header: "text-[24px] text-bold text-[#FFE000] mb-[10px] text-center w-screen",
        container: "gap-4 flex flex-col items-center",
        collapsedEvent: {
          container:
            "h-[64px] border-[#FFFFFF] border-[1px] bg-[#000000] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          duration: "text-[12px] text-[#FFFFFF] uppercase mt-[-8px]",
          name: "text-[20px] leading-[22px] mb-1 one-line-truncate text-[#FFFFFF] font-bold sm:w-[390px] w-[65vw]",
          plusIconColor: "#FFFFFF",
          media: "overflow-hidden m-2 rounded-full",
        },
        event: {
          container:
            "overflow-hidden border-[#FFFFFF] border-[1px] bg-[#000000] sm:w-[500px] w-[95vw]",
          name: "text-[20px] leading-[22px] mb-1 text-[#FFFFFF] font-bold sm:w-[390px] w-[65vw]",
          startDate:
            "!w-[64px] text-[#FFFFFF] h-[64px] bg-[#FB5058] flex flex-col justify-center items-center gap-1 font-bold",
          duration: "text-[12px] text-[#FFFFFF] uppercase",
          location: "text-[12px] text-[#FFFFFF] mb-4",
          button:
            "flex font-bold px-[16px] w-fit rounded-full text-bold justify-center items-center !text-[24px] !h-[48px] bg-[#FFFFFF] !text-[#000000] text-nowrap cursor-pointer",
          product: {
            container:
              "h-[74px] border-t border-t-[#FFFFFF] px-4 items-center flex justify-between",
            name: "text-[20px] leading-[22px] mb-1 text-[#FFFFFF] font-bold one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#FFFFFF] text-[16px] uppercase",
            status: "text-[#FFFFFF] text-[12px] uppercase",
            link: "text-[#FFFFFF] text-[12px] uppercase",
            button:
              "flex font-bold px-[16px] rounded-full text-bold justify-center items-center !text-[24px] !h-[48px] bg-[#FFFFFF] !text-[#000000] text-nowrap cursor-pointer",
          },
        },
        seeAllEvents: "text-[12px] text-center text-[#FFFFFF] mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[32px] rounded-full border-[2px] border-[#FFFFFF] !h-[56px] text-[#FFFFFF] text-[#FFFFFF] sm:w-[500px] w-[95vw] p-4 flex bg-[#000000] items-center text-[18px]",
        header: "text-[24px] text-bold text-[#FB5058] mb-[10px] text-center w-screen",
        oneNews: {
          container:
            "pr-2 overflow-hidden bg-[#FFFFFF] h-[68px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          name: "text-[20px] leading-[22px] mb-1 one-line-truncate font-bold sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[12px] mt-[-7px]",
          media: "overflow-hidden m-2 rounded-full h-[24px] w-[24px] ml-3 mt-[22px]",
        },
        seeAllNews: "text-[12px] text-center text-[#FFFFFF] mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[32px] rounded-full border-[2px] border-[#FFFFFF] !h-[56px] text-[#FFFFFF] text-[#FFFFFF] sm:w-[500px] w-[95vw] p-4 flex bg-[#000000] items-center text-[18px]",
        header: "text-[24px] text-bold text-[#00A990] mb-[10px] text-center w-screen",
        link: {
          container:
            "h-[56px] border-[1px] border-[#FFFFFF] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000]",
          name: "text-[20px] leading-[22px] mb-[6px] mt-[8px] one-line-truncate text-[#FFFFFF] font-bold sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFFFFF",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#FFFFFF] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "uppercase font-mono text-[11px] font-bold text-[#FFFFFF]",
      },
    },
  },
}

export default echobox
